export default __webpack_public_path__ + "assets/1e11e1b2c877d7ba024747c7a8efa9ab.png";